<template>
    <div class="lni-c-form-control"
            :class="{
            'lni-c-form-control--required': required,
            'lni-c-form-control--inline': inline,
            'lni-c-form-control--custom-width': customWidth
        }"
    >
        <label :for="controlId" class="lni-c-form-control__label">{{ labelText }}</label>
        <slot />
        <select
            :id="controlId"
            class="lni-c-form-control__select"
            v-model="value"
            @change="handleErrorState"
            :maxlength="maxlength"
            :required="required"
            >
            <option
                v-for="option in options"
                v-bind:key="option.value ? option.value : 'placeholder'"
                :value="option.value"
                :selected="option.value"
            >
                {{ option.text }}
            </option>
        </select>
    </div>
</template>

<script>
import framework from '../../framework';
/**
 *  The x-select component.
 *  @module components/x-select
 */


/**
 * The x-select is a basic select list.
 */

export default {
    name: 'x-select',
    mixins: [
        framework.mixins.abstractSingleValueInput,
    ],
    props: {
        dataOptions: Array,
        dataPlaceholder: String,
        dataLabelText: String,
    },
    mounted() {
        this.initialize();
    },
    computed: {
        /**
         * The text for the label.
         * @returns {string} label text.
         */
        labelText() {
            return this.getAttribute('labelText', '');
        },

        /**
         * The list of select options
         * @returns {*} array of options.
         */
        options() {
            return this.getOptions();
        },

        /**
         * The placeholder value.
         * @returns {string} placeholder value.
         */
        placeholder() {
            return this.getAttribute('placeholder', '');
        },
    },
    methods: {
        /**
         * Put the values onto the Html Inputs
         * @returns {void}
         */
        initializeHtmlInputs() {
            if (this.componentValue) {
                let el = this.$el.querySelector('select');
                el.value = this.componentValue;
            }
        },
        getErrorStateOffInputs() {
            return this.getSimpleErrorStateOffInputs('select');
        },
    },
};
</script>

<style lang="scss">
    @import
        "../../styles/settings.scss",
        "../x-input-text/input-text.scss";
</style>



// WEBPACK FOOTER //
// source/components/x-select/x-select.vue